export enum Action {
  Add,
  Edit
}